import { createReducer } from "@reduxjs/toolkit";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import type { ExternalProviderBatchRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { RetrievalState } from "@redux/state/shared-types";
import {
  adminRetrieveExternalProviderBatchRequest,
  resetAdminRetrieveExternalProviderBatchRequest,
} from "./retrieve-external-provider-batch-request";

const initialState: RetrievalState<Nullable<ExternalProviderBatchRequestVM>> = {
  fetching: "idle",
  data: null,
};

export const retrieveExternalProviderBatchRequestReducer = createReducer(initialState, builder => {
  builder.addCase(adminRetrieveExternalProviderBatchRequest.fulfilled, (_state, { payload }) => {
    return { fetching: "success", data: payload };
  });
  builder.addCase(adminRetrieveExternalProviderBatchRequest.pending, state => {
    return { ...state, fetching: "pending" };
  });
  builder.addCase(adminRetrieveExternalProviderBatchRequest.rejected, state => {
    return { ...state, fetching: "failed" };
  });
  builder.addCase(resetAdminRetrieveExternalProviderBatchRequest, () => initialState);
});
